// /src/components/BookingConfirmationModal.jsx
import { useRef } from 'react';
import { format } from 'date-fns';
import useModalA11y from '../hooks/useModalA11y';


function BookingConfirmationModal({
    isOpen,
    onClose,
    onConfirm,
    doctorName,
    isLoading,
    isSendMessage,
    onToggleSendMessage,
    appointmentTime, // Full ISO UTC string
}) {
    const dialogRef = useRef(null);

    useModalA11y({
        isOpen,
        dialogRef,
        onClose,
        closeOnEscape: !isLoading,
    });

    if (!isOpen) {
        return null;
    }
    const formattedTime = format(appointmentTime,'PPP pp');

    const handleCheckboxChange = (e) => {
        onToggleSendMessage(e.target.checked);
    };
    
    const checkBoxClasses = "h-6 w-6 flex-grow-0 flex-shrink-0 self-start border-2 rounded border-neutral-dark text-primary focus:ring-2 focus:ring-primary checked:bg-primary";

    return (
        <div
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
            //onClick={onClose} // Close on backdrop click
        >
            <div
                ref={dialogRef}
                role="dialog"
                aria-modal="true"
                aria-labelledby="bookingConfirmationTitle"
                tabIndex={-1}
                className="bg-white rounded-lg shadow-xl p-6 w-full max-w-md"
                onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside modal
            >
                <h2 id="bookingConfirmationTitle" className="text-2xl font-semibold mb-4 text-primary-dark">Confirm Appointment</h2>
                <p className="mb-2 text-gray-700">Please confirm the details for your upcoming appointment:</p>
                <div className="mb-4 p-3 bg-gray-100 rounded border border-gray-200">
                    <p><span className="font-medium">Doctor:</span> {doctorName}</p>
                    <p><span className="font-medium">Date & Time:</span> {formattedTime}</p>
                    <p className="text-xs text-gray-500">(Time shown in your local timezone)</p>
                </div>

                <div className="flex justify-end space-x-3">
                    <button
                        type="button"
                        onClick={onClose}
                        disabled={isLoading}
                        className="px-4 py-2 bg-gray-300 text-gray-800 rounded-md hover:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-opacity-50 disabled:opacity-50"
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        onClick={onConfirm}
                        disabled={isLoading}
                        className="px-4 py-2 bg-button text-white rounded-md hover:bg-button-light focus:outline-none focus:ring-2 focus:ring-primary focus:ring-opacity-50 disabled:opacity-50 flex items-center justify-center min-w-[100px]"
                    >
                        Book Appointment                      
                    </button>
                </div>
                <div className="flex items-center justify-center mt-4">
                    <input
                        type="checkbox"
                        id="sendMessage"
                        name="sendMessage"
                        checked={isSendMessage}
                        onChange={handleCheckboxChange}
                        className={checkBoxClasses}
                    />
                    <label htmlFor="sendMessage" className="ml-3 block text-sm text-neutral-dark">
                        Receive a confirmation email and/or text message.
                    </label>
                </div>
            </div>
        </div>
    );
}

export default BookingConfirmationModal;
